module.exports = __webpack_public_path__ + "static/media/SAM.c6ba7879.mp4";